'use client';

import { WatchlistFinancials } from '../../data';
import { WatchlistStats } from '../WatchlistPerformance/processors';
import { TradeNowButton } from '../WatchlistPerformance/TradeNowButton';

const performerLabel = (type: 'best' | 'worst') => (type === 'best' ? 'Best performer' : 'Worst performer');

export const PerformerCard = ({ ticker, type }: { ticker: WatchlistFinancials; type: 'best' | 'worst' }) => {
  const changePercent = ticker.quote?.changePercent;
  const isPositive = typeof changePercent === 'number' && changePercent > 0;
  const isNegative = typeof changePercent === 'number' && changePercent < 0;

  return (
    <div className="flex h-full min-h-[7.5rem] flex-col gap-2 bg-bzblue-800 p-3">
      <p className="text-xs font-medium text-slate-300">{performerLabel(type)}</p>
      <div className="flex flex-1 items-center">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span className="text-2xl font-bold tracking-tight text-white">{ticker.symbol}</span>
          <span
            className={`text-sm font-bold tabular-nums ${
              isPositive ? 'text-green-300' : isNegative ? 'text-red-300' : 'text-white/80'
            }`}
          >
            {typeof changePercent === 'number' ? `${changePercent.toFixed(2)}%` : '—'}
          </span>
        </div>
      </div>
      <div className="w-fit">
        <TradeNowButton compact />
      </div>
    </div>
  );
};

export const Performers = ({ stats }: { stats: WatchlistStats }) => (
  <>
    {stats.best_ticker && <PerformerCard ticker={stats.best_ticker} type="best" />}
    {stats.worst_ticker && <PerformerCard ticker={stats.worst_ticker} type="worst" />}
  </>
);
